<div class="ob-popup-wrap" [class.visible]="visible" *ngIf="offer">

  <!-- Close button -->
  <button class="ob-popup-close" (click)="dismiss()" aria-label="Close">✕</button>

  <!-- Clickable card -->
  <div class="ob-popup-card" (click)="onBannerClick()">

    <!-- Full-width image on top -->
     
    <div class="ob-popup-img-wrap">
      <img [src]="imageSrc()" [alt]="offer.title" class="ob-popup-img" />
      
    </div>

    <!-- Text below image -->
    <div class="ob-popup-text">
      <strong class="ob-popup-title">{{ offer.title }}</strong>
      <span class="ob-popup-desc" *ngIf="offer.description">{{ offer.description }}</span>
    </div>

    <!-- Full-width CTA -->
    <div class="ob-popup-footer">
      <button class="ob-popup-cta">Register Now →</button>
    </div>

  </div>

</div>